import config from './config'
import PageImageView from './views/page-image'
import ReportingView from './views/reporting';
import ResultView from './views/result';
import TestView from './views/test'
import TestModel from './models/test'
import Maks2PageImageView from './overrides/maks2/views/page-image'
import Maks2TestView from './overrides/maks2/views/test'
import FrpTestModel from './overrides/frp/models/test'
import FrpReportingView from './overrides/frp/views/reporting'
import FrpResultView from './overrides/frp/views/result'
import FrpTestView from './overrides/frp/views/test'
import TimesTableOneToSixView from './overrides/maks2/views/times-table-1-6'
import TimesTableSevenToTwelveView from './overrides/maks2/views/times-table-7-12'
import TimesTableMenuView from './overrides/maks4f/views/times-table-menu'

const overrides = {
    default: {
        views: {
            'page-image': PageImageView,
            'reporting': ReportingView,
            'result': ResultView,
            'test': TestView,
        },
        models: {
            'test': TestModel
        },
    },
    maks2: {
        views: {
            'page-image': Maks2PageImageView,
            'test': Maks2TestView,
        },
        titleOverrides: {
            test: {
                'times-tables-1-6': TimesTableOneToSixView,
                'times-tables-7-12': TimesTableSevenToTwelveView,
            }
        }
    },
    maks3: {
        models: {
            'test': FrpTestModel
        },
        views: {
            'reporting': FrpReportingView,
            'result': FrpResultView,
            'test': FrpTestView,
        }
    },
    maks4f: {
        models: {
            'test': FrpTestModel
        },
        views: {
            'reporting': FrpReportingView,
            'result': FrpResultView,
            'test': FrpTestView,
        },
        titleOverrides: {
            test: {
                'multiplication-chart': TimesTableMenuView,
            }
        }
    },
    maks4fwjec: {
        models: {
            'test': FrpTestModel
        },
        views: {
            'reporting': FrpReportingView,
            'result': FrpResultView,
            'test': FrpTestView,
        }
    },
    maks4h: {
        models: {
            'test': FrpTestModel
        },
        views: {
            'reporting': FrpReportingView,
            'result': FrpResultView,
            'test': FrpTestView,
        }
    },
    maks4hwjec: {
        models: {
            'test': FrpTestModel
        },
        views: {
            'reporting': FrpReportingView,
            'result': FrpResultView,
            'test': FrpTestView,
        }
    },
}

/**
 * Return a specific View class or a default fallback.
 * Automatically fetches the current slug from config.
 */
export function loadView(viewName, image_prefix) {
    const slug = config.get('slug')
    const appOverrides = overrides[slug] || overrides.default

    // If there is a title override for the given view and image_prefix, use it.
    if (appOverrides.titleOverrides && appOverrides.titleOverrides[viewName]) {
        const titleMap = appOverrides.titleOverrides[viewName]
        if (titleMap[image_prefix]) {
            return titleMap[image_prefix]
        }
    }

    return (
        appOverrides.views?.[viewName] ||
        overrides.default.views?.[viewName] ||
        null
    )
}

/**
 * Return a specific Model class or a default fallback.
 * Automatically fetches the current slug from config.
 */
export function loadModel(modelName) {
    const slug = config.get('slug')
    const appOverrides = overrides[slug] || overrides.default

    return (
        appOverrides.models?.[modelName] ||
        overrides.default.models?.[modelName] ||
        null
    )
}

// (Optional) If you want direct access to the entire overrides object:
export default overrides
